import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {
    DashboardCard,
    httpGetAccessesDashboard,
    HttpGetAccessesDashboardOptions,
    HttpGetAccessesDashboardResponse
} from '@/features/accesses/http/accesses.http'

export const useGetAccessesDashboard = <T extends DashboardCard>(
    urlParams?: HttpGetAccessesDashboardOptions<T>,
    options?: Omit<UseQueryOptions<HttpGetAccessesDashboardResponse<T>>, 'queryKey' | 'queryFn'>
) => {
    return useQuery({
        queryKey: [QUERY_KEYS.ACCESSES, QUERY_KEYS.ACCESSES_DASHBOARD, urlParams],
        queryFn: () => httpGetAccessesDashboard({payload: urlParams?.payload, params: urlParams?.params}),
        ...options
    })
}
